import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../../config";

const ExpenseCategory = () => {
  const [categories, setCategories] = useState([]);
  const [catFormData, setCatFormData] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/api/expense-category`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setCategories(response.data.categories);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCatChange = (e) => {
    setCatFormData({ ...catFormData, [e.target.name]: e.target.value });
  };

  const submitCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(`${API_URL}/api/expense-category`, catFormData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        alert(res.data.message);
        setCatFormData({ name: '', description: '' });
        fetchCategories();
      } else {
        alert(res.data.message);
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Error processing request');
    }
    setLoading(false);
  };

  const deleteCategory = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.delete(`${API_URL}/api/expense-category/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message);
          fetchCategories();
        }
      } catch (error) {
        alert('Error deleting category');
      }
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px' }}>Expense Categories</h2>
      
      <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
        <h4 style={{ marginBottom: '15px' }}>Add Expense Category</h4>
        <form onSubmit={submitCategory} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Category Name</label>
            <input 
              type="text" name="name" value={catFormData.name} onChange={handleCatChange} required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Description (Optional)</label>
            <input 
              type="text" name="description" value={catFormData.description} onChange={handleCatChange} 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          
          <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>
            <button 
              type="submit" disabled={loading}
              style={{ padding: '10px 20px', backgroundColor: '#003e6d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
            >
              {loading ? 'Adding...' : 'Add Category'}
            </button>
          </div>
        </form>
      </div>

      <h3 style={{ marginBottom: '20px' }}>Expense Categories List</h3>
      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '12px' }}>Category Name</th>
              <th style={{ padding: '12px' }}>Description</th>
              <th style={{ padding: '12px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {categories.length > 0 ? (
              categories.map(category => (
                <tr key={category._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '12px' }}>{category.name}</td>
                  <td style={{ padding: '12px' }}>{category.description || '-'}</td>
                  <td style={{ padding: '12px' }}>
                    <button 
                      onClick={() => deleteCategory(category._id)} 
                      style={{ background: '#dc3545', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ padding: '20px', textAlign: 'center' }}>No Expense Categories Added Yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExpenseCategory;
